import { StationStatus } from "@/api/api";

// appears for non-community stations when status = down or last reading was more than 1 hour ago
export function isDownStation(station: any): boolean {
    const status = String(station.status).trim();
    if (status === StationStatus.community || status === StationStatus.retired) {
        return false;
    }

    const lastReadingAt = station.lastReadingAt;
    const now = Date.now();
    const downThreshold = now - 60 * 60 * 1000; // 1 hour ago

    return !lastReadingAt || new Date(lastReadingAt).getTime() < downThreshold || status === StationStatus.down;
}

export function isRetiredStation(station: any): boolean {
    return String(station.status).trim() === StationStatus.retired;
}

export function isCommunityStation(station: any): boolean {
    return String(station.status).trim() === StationStatus.community;
}
